import { baseTheme } from './base';

import { ReactComponent as ClubeAsesLogoSvg } from '../assets/LOGO-ASES-AZUL-FUNDO-BRANCO.svg';

export const clubeAsesTheme = {
  ...baseTheme,
  empresaId: 7526, // ← coloca o ID real do cliente aqui
  //empresaId: 4157,
  Logo: ClubeAsesLogoSvg,

  auth: {
    //login: 'cliente.clubeases', // ← credencial real
    //password: 'senha_real',

    login: 'cliente.ases',
    //password: '123456a',
    password: 'leankeep2026',
  },

  labels: {
    ...baseTheme.labels,
    formTitle: 'Queremos te ouvir',
    formSubtitle: 'Use o formulário abaixo para enviar seu chamado, sugestão ou crítica.',
    category: 'Categoria*',
  },

  fields: {
    ...baseTheme.fields,
    nome: false,
    area: false,
    solicitationType: false,
    email: false,
    fotos: false,
    category: true,
    ambienteQrCodeTable: true,
  },

  colors: {
    ...baseTheme.colors,
    pageBg: '#ebebeb',
    primary: '#2065b4',
    primaryText: '#ffffff',
    primaryBorder: '#2065b4',
    textTitle: '#0d2d54',
  },

  typography: {
    ...baseTheme.typography,
    titleFont: 'Inter',
  },
};
